import { useContext } from "react"
import { PermissionContext } from "context/index"

const usePermission = () => {
	return useContext(PermissionContext)
}

export default usePermission